<template>
    <div class="clearfix pb-3 px-0 ml-0">  <!-- abdullah chnaged calss here. was clearfix company-form-container rounded mt-4 pb-5 mx-auto pl-3 pr-3 -->

           <!-- Abdullah26 added this code here  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0" v-if="this.flg != 1">HR Settings<span>
                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / HR Settings / Departments</span>
        </h4>

        <b-alert v-model="hasDraft" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info" dismissible>There are some draft departments.</b-alert>
        <div class="row no-margin mt-4">
            <div class="ibox col-md-12 px-4 employee-table-wrapper">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Departments</h4>
                </div>
                <div class="row"><!-- abdullah added this div -->
                    <div class="col-md-6">  <!-- abdullah chnaged calss here. was col-sm-6 -->
                        <div class="custom-search w-100">  <!-- abdullah chnaged calss here. was custom-search float-right w-100 -->
                            <b-input-group class="mb-0">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <div class="col-md-6 text-right"> <!-- Abdullah changed class. it was col-sm-5 float-right text-right px-0 and removed v-if="permission >= 2" -->
                        <b-button id="show-btn" class="mr-3 custom-wizard-btn" @click="addNew(true)">Add Multiple Departments</b-button> <!-- Abdullah added class custom-wizard-btn -->
                        <b-button id="show-btn" class="btn-primary" @click="addNew(false)">Add Department</b-button>  <!-- Abdullah added class btn-primary -->
                    </div>
                </div>

                <!-- Abdullah added this code here -->
                <div class="ibox-content px-0 mt-4">
                    <b-overlay :show="showoverlay_list" rounded="sm" class="">
                        <table class="table">
                            <thead>
                                <tr class="table-head">
                                    <td style="width: 60px;" class="">#SL</td>
                                    <td>Department Title</td>
                                    <td style="width: 100px;" v-if="permission >= 2" class="">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(department , n) in paginatedData" :key="department.id">
                                   <!-- alpha fix- added text-center  -->
                                    <td class="align-middle list-columns text-center">{{department.index}}</td>

                                    <td class="align-middle list-columns">
                                        <template v-if="department.name_draft">{{department.name_draft}}</template>
                                        <template v-else>{{department.name}}</template>
                                    </td>

                                    <td class="clearfix align-middle" v-if="permission >= 2">
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mr-0">
                                                        <b-button variant="outline-secondary" title="Edit Department" @click="editDepartment(department.id)">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                        </b-button>
                                                        <b-button v-if="permission == 2" variant="outline-secondary" title="Delete Department" @click="deleteDepartment(department.id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                                </ul>
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                            </div>
                        </div>

                        <div v-if="this.flg == 1" class="mt-3">
                           <div class="text-center">

                            <b-button type="button" @click="set_go_back(1)" variant="primary" class="btn-primary mt-3 mr-3">Go Back</b-button>
                            <b-button type="button" @click="setfinish(1)" variant="success" class="custom-wizard-btn  btn-primary mt-3 mx-3">Finish</b-button>
                            <b-button type="button" @click="set_go_next(1)" variant="primary" class="btn-primary mt-3 mr-3">Go Next</b-button>
                           </div>
                        </div>

                    </b-overlay>
                </div>
            </div>
        </div>

        <!-- Abdullah Commented this code  -->
        <!-- <div class="clearfix row py-2 mb-2 border-bottom">
            <div class="col-sm-3 px-3 company-form-box-title">Departments</div>  -->

            <!-- </div>
        </div>  -->

        <div class="row justify-content-center">
            <div class="col-sm-12  px-0" v-if="permission >= 2">
                <b-modal id="bv-modal-department" size="lg" hide-footer :title="department_details"> <!-- Abdullah chnaged title here  -->
                    <b-overlay :show="showoverlay" rounded="sm">

                        <template v-if="fdata.id > 0">
                            <b-form @submit.stop.prevent="onSubmit">
                                <div class="clearfix">
                                    <div class="px-3">
                                        <input type="hidden" v-model="fdata.id" name="id">

                                        <!-- Abdullah26 added radius-8  -->
                                        <b-form-group  id="name-group" label="Department Title" class="required-field" label-for="name">  <!-- Abdullah chnaged title to Depertment title  -->
                                            <b-input-group>
                                                <b-form-input class="radius-8" id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>

                                                <b-input-group-append v-if="fdata.name_draft" v-b-tooltip.hover :title="saved_name"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>

                                        <template v-if="(fdata.name_draft) && (permission == 2)">
                                            <div class="btn-wrapper text-center pt-5">
                                                <!-- <b-button type="submit" variant="success" >Approve</b-button>  Abdullah commented this  -->
                                                <b-button class="btn-primary" type="submit" variant="primary" >Approve</b-button>
                                                <!-- <b-button v-if="(fdata.name_draft) && (permission == 2)" @click="resetDepartment(fdata.id)" type="button" variant="success" >Reset</b-button>  Abdullah commetd this -->
                                                <b-button class="btn-primary" v-if="(fdata.name_draft) && (permission == 2)" @click="resetDepartment(fdata.id)" type="button" variant="primary" >Reset</b-button>
                                            </div>

                                        </template>
                                        <template v-else>
                                            <!-- <b-button type="submit" variant="success" >Save</b-button>  Abdullah Commented this -->
                                            <div class="btn-wrapper text-center pt-5">

                                                <!-- Abdullah after live chnaged this btn title  -->
                                                <b-button class="btn-primary" type="submit" variant="primary" >Update</b-button>
                                            </div>
                                        </template>

                                    </div>
                                </div>
                            </b-form>

                        </template>
                        <template v-else>
                            <b-form @submit.stop.prevent="onSubmit">
                                <div class="clearfix">
                                    <div class="px-3">
                                        <input type="hidden" v-model="fdata.id" name="id">

                                        <template v-if="addtype == true">
                                            <b-form-group id="name-group" label="Department Title(s)" class="required-field gray-textarea" label-for="name" description="Add new department title in new line for multiple entry"> <!-- Abdullah added class here  gray-textarea -->
                                                <b-form-textarea id="name" name="name" rows="5" v-model="fdata.name" v-validate="{ required: true }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Department Title"></b-form-textarea>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>

 <!-- Abdullah26 added radius-8  -->
                                        <template v-else>
                                            <b-form-group id="name-group" label="Department Title" class="required-field" label-for="name">
                                                <b-form-input class="radius-8" id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Department Title"></b-form-input>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>

                                        <!-- Abdullaj commented this  -->
                                        <!-- <label style="opacity: 0;">label</label>
                                        <b-button v-if="fdata.id > 0" type="submit" variant="success" style="width: 100%;"><b-icon variant="light" icon="pencil" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Edit Department</b-button>
                                        <b-button v-else type="submit" variant="success" style="width: 100%;"><b-icon variant="light" icon="plus-circle" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Add Department</b-button> -->

                                        <!-- Abdullah added this -->
                                        <div class="btn-wrapper text-center pt-5">
                                            <label style="opacity: 0; display: none;">label</label>
                                            <b-button class="btn-primary" v-if="fdata.id > 0" type="submit" variant="primary" style="">Edit Department</b-button>
                                            <b-button class="btn-primary" v-else type="submit" variant="primary" style="">Submit</b-button>
                                        </div>
                                    </div>
                                </div>
                            </b-form>
                        </template>
                    </b-overlay>
                </b-modal>

                <b-modal id="bv-modal-department-draft" size="lg" hide-footer title="Department Details">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="saveDraftDepartment">
                            <div class="clearfix">
                                <div class="px-3">
                                    <input type="hidden" v-model="draftdata.id" name="id">
 <!-- Abdullah26 added radius-8  -->
                                    <b-form-group id="name-group" label="Department Title" class="required-field" label-for="name">
                                        <b-form-input class="radius-8" id="name" name="name" v-model="draftdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Department Title"></b-form-input>
                                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <label style="opacity: 0;">label</label>
                                    <b-button type="submit" variant="success" style="width: 100%;"><b-icon variant="light" icon="pencil" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Update Draft Data</b-button>
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>



            <!-- Abdullah commented this  -->
            <!-- <div class="col-sm-12  px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table list-tables">
                        <thead>
                            <tr class="table-head">
                                <td class="pl-5">#</td>
                                <td class=""></td>
                                <td>Department Title</td>
                                <td v-if="permission >= 2" class="float-right">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(department , n) in paginatedData" :key="department.id">
                                <td class="col-md-1 align-middle list-columns pl-5">{{department.index}}</td>
                                <td class="">
                                    <b-icon v-if="department.name_draft" icon="pencil-square" v-b-tooltip.hover :title="department.name"></b-icon>
                                </td>
                                <td class="col-md-5 align-middle list-columns">
                                    <template v-if="department.name_draft">{{department.name_draft}}</template>
                                    <template v-else>{{department.name}}</template>
                                </td>

                                <td class="clearfix col-md-6 align-middle" v-if="permission >= 2">
                                    <div class="float-right mr-2 position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                             <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">
                                                    <b-button class="mr-3 rounded edit-btn" title="Edit Department" @click="editDepartment(department.id)">
                                                        <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                    </b-button>
                                                    <b-button v-if="permission == 2" class="rounded delete-btn" title="Delete Department" @click="deleteDepartment(department.id)">
                                                        <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                    <div v-else class="px-3">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                    </div>



                    <div v-if="this.flg == 1" class="mt-3">
                        <b-button type="button" @click="set_go_next(1)" variant="primary" class="float-right mt-3 mr-3">Go Next</b-button>
                        <b-button type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go Back</b-button>
                        <b-button type="button" @click="setfinish(1)" variant="success" class="float-right mt-3 mx-3">Finish</b-button>
                    </div>

                </b-overlay>
            </div> -->
            <!-- Abdullah commented this. upto this  -->
            <div class="col-sm-12  px-0 mt-5" v-if="draft_departments.length > 0">

                <div class="px-3 mb-2 company-form-box-title">New Departments (Waiting for Approval)</div>

                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table list-tables">
                        <thead>
                            <tr class="table-head">
                                <td class="pl-5">#</td>
                                <td>Department Title</td>
                                <td v-if="permission >= 2" class="float-right">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(department , n) in draft_departments" :key="department.id">
                                <td class="col-md-1 align-middle list-columns pl-5">{{ parseInt(n+1) }}</td>
                                <td class="col-md-5 align-middle list-columns">
                                    <div class=" ">{{department.name}}</div>
                                </td>

                                <td class="clearfix col-md-6 align-middle" v-if="permission >= 2">
                                    <div class="float-right mr-2 position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                             <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">


                                                    <!-- abdullah added variant in all 3 and remove classes from here. the classes was class="mr-3 rounded edit-btn"x2, class="rounded delete-btn" -->
                                                    <b-button v-if="permission == 2"variant="outline-secondary" title="Approve Department" @click="approveDepartment(department.id)">
                                                        <b-icon icon="check2" class="mr-2" aria-hidden="true" ></b-icon>Approve
                                                    </b-button>
                                                    <b-button variant="outline-secondary" title="Edit Department" @click="editDraftDepartment(department.id)">
                                                        <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                    </b-button>
                                                    <b-button variant="outline-secondary" title="Delete Department" @click="deleteDraftDepartment(department.id)">
                                                        <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-overlay>
            </div>
        </div>
    </div>
</template>


<script>
    export default{

        mounted() {
            this.permission = this.$acl['department/details'];
        },
        props: ['ce_flg' , 'check_ce' , 'flg'],
        data(){

            return {

                departments:[],
                draft_departments : [],
                errormsg:[],
                fdata: {status:null , id:null},
                saved_name : '',
                // Abdullah added this
                successmsg:null,
                warningmsg:null,

                draftdata : {},
                file: null,
                showoverlay:false,
                showoverlay_list:false,
                go_back : false,
                go_next : false,
                finish : false,

                search:'',
                length: 20,
                temp_length:20,
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],

                people:0,
                pagination: {currentPage: 1, pages:1},

                successmsg:false,
                warningmsg:false,
                dangermsg:false,

                addtype : false,


                permission : 0,
                hasDraft : false,
                // Abdullah added this
                department_details: 'Department Details',
            }
        },
        methods:{

            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.departments.length > 0)tmp_flg = 1;
                let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , move_back:this.go_back , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x){
                this.go_next = false;
                this.go_back = true;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            set_go_next(x){
                this.go_next = true;
                this.go_back = false;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
            setfinish(x){
                this.finish = true;

                this.go_next = false;
                this.go_back = false;

                if(x == 1)
                    this.showMessage();
            },
            addNew(x)
            {
                this.addtype = x;
                this.resetForm();
                // abullah added this if else
                if(x == true){
                    this.department_details = 'Add Multiple Departments';
                }else{
                    this.department_details = 'Add Department';
                }
                this.$bvModal.show('bv-modal-department');
                //this.newagent = true;
            },

            getDepartmentData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/department/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.departments = response.data;
                    this.people = this.departments.length;
                    //this.showMessage();

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            getDraftDepartmentData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/department/list/draft' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.draft_departments = response.data;

                    if(this.draft_departments.length > 0)
                        this.hasDraft = true;
                    else
                        this.hasDraft = false;

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            editDraftDepartment:function(x)
            {
                // Abdullah added this line
                this.department_details = 'Edit Department';
                this.addtype = false;
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;
                axios.get(this.$api_url+'/department/details/draft' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.draftdata = response.data;
                    this.$validator.reset();
                    this.showoverlay = false;
                    this.$bvModal.show('bv-modal-department-draft');
                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);}); ;
            },
            saveDraftDepartment(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.draftdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/department/save/draft', formData)
                                .then(function (response)
                                {
                                    this.getDraftDepartmentData();
                                    this.successmsg = 'Saved!';
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    this.resetForm();
                                    this.$bvModal.hide('bv-modal-department-draft');

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                });
                });
            },
            deleteDraftDepartment:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this draft department.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/department/delete/draft', formData).then(function(response){
                            this.getDraftDepartmentData();
                            this.$bvToast.toast('Deleted!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            approveDepartment:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to approve this draft department.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/department/approve/draft', formData).then(function(response){

                            this.getDepartmentData();
                            this.getDraftDepartmentData();

                            this.$bvToast.toast('Approved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },
            resetDepartment:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to reset this department data.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/department/reset', formData).then(function(response){

                            this.getDepartmentData();
                            this.editDepartment(x);

                            this.$bvToast.toast('Saved', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },



            editDepartment:function(x)
            {
                // abdullah added this line
                this.department_details = 'Edit Department';
                this.addtype = false;
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;
                axios.get(this.$api_url+'/department/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.saved_name = response.data.name;

                    if((this.fdata.name_draft != '') && (this.fdata.name_draft != null))
                        this.fdata.name = this.fdata.name_draft;


                    this.$validator.reset();
                    this.showoverlay = false;
                    this.$bvModal.show('bv-modal-department');
                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);}); ;
            },


            deleteDepartment:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this department.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        let currentObj = this;
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/department/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.departments = response.data.departments;
                                this.resetPagination();
                            }
                            else
                            {
                                this.warningmsg = response.data.meg;

                                this.$bvToast.toast(response.data.meg, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        });

                                //alert(response.data.meg);
                            }
                            this.showoverlay_list = false;
                            //this.showMessage();

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                        });
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {name:null, status:null, id:null};
                this.file = null;
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;
                //this.showMessage();
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/department/save', formData, config)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    this.departments = response.data;

                                    this.getDraftDepartmentData();

                                    this.successmsg = 'Saved!';
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    this.resetForm();
                                    //this.movenext = true;
                                    //this.showMessage();
                                    this.$bvModal.hide('bv-modal-department');

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                });
                });
            },

        },
        created: function(){
            this.getDepartmentData();
            this.getDraftDepartmentData();
            Fire.$on('reloadUsers', () => {this.getDepartmentData()});
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.departments;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {

                //console.log(this.length);
                //console.log(this.filteredData);

                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
